import { render, staticRenderFns } from "./ReferenceEmailTemplatesSettings.vue?vue&type=template&id=5d31ae2a&scoped=true"
import script from "./ReferenceEmailTemplatesSettings.vue?vue&type=script&lang=js"
export * from "./ReferenceEmailTemplatesSettings.vue?vue&type=script&lang=js"
import style0 from "./ReferenceEmailTemplatesSettings.vue?vue&type=style&index=0&id=5d31ae2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d31ae2a",
  null
  
)

export default component.exports